import React from 'react'
import groupApi from '_api/group'
import GroupMap from '_components/GroupMap/GroupMap'
import useLandingGroupAction from '../hooks/useLandingGroupAction'

const searchMapGroups = (keyword) =>
  groupApi.searchGroupsMap(keyword).then((res) => res?.msgResp || [])

const HeroSection = ({ stats, mapGroups, onJoinMember, onBecomeHost }) => {
  const getMapAction = useLandingGroupAction()

  return (
    <section className='hero-section'>
      <div className='hero-section__pattern' />
      <div className='landing-shell hero-section__grid'>
        <div className='hero-copy'>
          <div className='hero-copy__badge'>
            <span className='hero-copy__dot' />
            {stats.totalEvents.toLocaleString()} group buys completed
          </div>

          <h1 className='hero-copy__title'>
            Buy together.
            <br />
            Save <em>more.</em>
          </h1>

          <p className='hero-copy__text'>
            Buying together has never been easier—save more, share more, and enjoy exclusive deals
            as a community! Co-bee makes group-buy simple, fun, and hassle-free.
            <span className='hero-copy__welcome'>We welcome you to join our community!</span>
          </p>

          <div className='hero-copy__actions'>
            <button type='button' className='button-primary' onClick={onJoinMember}>
              🐝 Join as Member
            </button>
            <button type='button' className='button-secondary' onClick={onBecomeHost}>
              Become a Host
            </button>
          </div>
        </div>

        <div className='hero-visual'>
          <GroupMap
            groups={mapGroups}
            title='Find hosts near you'
            getAction={getMapAction}
            searchGroups={searchMapGroups}
          />

          <div className='hero-stats'>
            <div className='hero-stats__item'>
              <div className='hero-stats__value'>{stats.totalMembers.toLocaleString()}</div>
              <div className='hero-stats__label'>Active members</div>
            </div>
            <div className='hero-stats__item'>
              <div className='hero-stats__value'>{stats.totalEvents.toLocaleString()}</div>
              <div className='hero-stats__label'>Events hosted</div>
            </div>
            <div className='hero-stats__item'>
              <div className='hero-stats__value'>{stats.totalGroups.toLocaleString()}</div>
              <div className='hero-stats__label'>Community groups</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroSection
